import { useEffect, useRef } from 'react';

export const useInitialFormState = (initialData, setForm, preserveKeys = []) => {
  const prevDataRef = useRef(null);

  useEffect(() => {
    if (!initialData) return;

    const prevDataStr = JSON.stringify(prevDataRef.current);
    const nextDataStr = JSON.stringify(initialData);

    if (prevDataStr === nextDataStr) return;

    prevDataRef.current = initialData;

    setForm(prev => {
      const preserved = {};
      for (const key of preserveKeys) {
        const prevVal = prev?.[key];
        const incomingVal = initialData?.[key];

        if (Array.isArray(prevVal) && (!incomingVal || incomingVal.length === 0)) {
          preserved[key] = prevVal;
        }
      }

      const nextState = {
        ...(initialData || {}),
        ...preserved
      };

      const currentWithoutPreserved = { ...prev };
      preserveKeys.forEach(key => delete currentWithoutPreserved[key]);

      const nextWithoutPreserved = { ...nextState };
      preserveKeys.forEach(key => delete nextWithoutPreserved[key]);

      const hasChanged = JSON.stringify(currentWithoutPreserved) !== JSON.stringify(nextWithoutPreserved);
      return hasChanged ? { ...prev, ...nextState } : prev;
    });
  }, [initialData, preserveKeys, setForm]);
};